/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { VisitFormListItem } from './VisitFormListItem';
import {
    VisitFormListItemFromJSON,
    VisitFormListItemFromJSONTyped,
    VisitFormListItemToJSON,
} from './VisitFormListItem';

/**
 * Response for list visit forms endpoint with pagination.
 * @export
 * @interface VisitFormListResponse
 */
export interface VisitFormListResponse {
    /**
     * Total number of visit forms matching filter
     * @type {number}
     * @memberof VisitFormListResponse
     */
    total: number;
    /**
     * List of visit form summaries
     * @type {Array<VisitFormListItem>}
     * @memberof VisitFormListResponse
     */
    visitForms: Array<VisitFormListItem>;
}

/**
 * Check if a given object implements the VisitFormListResponse interface.
 */
export function instanceOfVisitFormListResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "total" in value;
    isInstance = isInstance && "visitForms" in value;

    return isInstance;
}

export function VisitFormListResponseFromJSON(json: any): VisitFormListResponse {
    return VisitFormListResponseFromJSONTyped(json, false);
}

export function VisitFormListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): VisitFormListResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total': json['total'],
        'visitForms': ((json['visit_forms'] as Array<any>).map(VisitFormListItemFromJSON)),
    };
}

export function VisitFormListResponseToJSON(value?: VisitFormListResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total': value.total,
        'visit_forms': ((value.visitForms as Array<any>).map(VisitFormListItemToJSON)),
    };
}

